import { getCurrentInstance } from 'vue'

export function useCan() {
    return getCurrentInstance()?.proxy?.$can
}
